import { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { ALL_PATHS } from 'app/shared/consts';

/**
 * The route PATTERN behind the current pathname (`/booking/:transactionUuid`), which is what tracking's
 * `route` means. Falls back to the pathname so an untracked route still reports something identifiable.
 */
export const useMatchedRoute = (): string => {
  const { pathname } = useLocation();

  return useMemo(() => ALL_PATHS.find((pattern) => matchPath(pattern, pathname)) ?? pathname, [pathname]);
};
